import { useEffect, useState } from "react";
import { api } from "../../lib/api";

const COLS = [["60", "SOLD @60s"], ["120", "held 2m"], ["300", "held 5m"], ["900", "held 15m"], ["3600", "held 1h"]];
const pct = (v) => (v == null ? "—" : `${v > 0 ? "+" : ""}${Number(v).toFixed(1)}%`);
const tone = (v) => (v == null ? "text-[var(--r2-text2)]" : v > 0 ? "text-[var(--r2-emerald)]" : "text-[var(--r2-red)]");
const when = (t) => (t ? new Date(t * 1000).toLocaleString([], { month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" }) : "—");

/* User 2026-10-25: every fast-mover buy is sold at 60 s — this shows what each did and what holding longer would have returned. */
export const FastMoverScorecard = () => {
  const [d, setD] = useState(null);
  useEffect(() => {
    const load = () => api.meme.fastMoverScorecard().then(setD).catch(() => {});
    load(); const t = setInterval(load, 60000); return () => clearInterval(t);
  }, []);
  if (!d) return null;
  const s = d.summary || {};
  const best = COLS.filter(([k]) => s[k]?.n).sort((a, b) => (s[b[0]].avg_pct ?? -1e9) - (s[a[0]].avg_pct ?? -1e9))[0];
  return (
    <div className="rounded-sm border border-[var(--r2-border)] p-2" data-testid="fast-mover-scorecard">
      <div className="mb-1 flex flex-wrap items-center gap-3 tracking-[0.14em]">
        <span className="font-black text-[var(--meme)]">FAST MOVER SCORECARD</span>
        <span className="text-[var(--r2-text2)]">{d.sol_per_buy} SOL per buy · sold at {d.hold_sec}s · {d.items?.length || 0} trades</span>
        <span className={tone(d.pnl_sol)} data-testid="fast-mover-scorecard-pnl">P&L {d.pnl_sol > 0 ? "+" : ""}{d.pnl_sol} SOL</span>
        {best && <span className="text-[var(--r2-cyan)]" data-testid="fast-mover-scorecard-best">best hold so far: {best[1]} ({pct(s[best[0]].avg_pct)} avg)</span>}
      </div>
      <table className="w-full text-left" data-testid="fast-mover-scorecard-summary">
        <thead className="text-[var(--r2-text2)]"><tr><th /> {COLS.map(([k, l]) => <th key={k}>{l}</th>)}</tr></thead>
        <tbody>
          <tr><td className="text-[var(--r2-text2)]">avg</td>{COLS.map(([k]) => <td key={k} className={tone(s[k]?.avg_pct)}>{pct(s[k]?.avg_pct)}</td>)}</tr>
          <tr><td className="text-[var(--r2-text2)]">win rate</td>{COLS.map(([k]) => <td key={k}>{s[k]?.n ? `${Math.round(s[k].win_rate * 100)}% (${s[k].n})` : "—"}</td>)}</tr>
        </tbody>
      </table>
      {d.items?.length ? (
        <table className="mt-2 w-full text-left" data-testid="fast-mover-scorecard-rows">
          <thead className="text-[var(--r2-text2)]"><tr><th>token</th><th>bought</th>{COLS.map(([k, l]) => <th key={k}>{l}</th>)}</tr></thead>
          <tbody>
            {d.items.map((r) => (
              <tr key={`${r.mint}-${r.opened_at}`} data-testid={`fast-mover-row-${r.mint}`}>
                <td><a href={`https://dexscreener.com/solana/${r.mint}`} target="_blank" rel="noreferrer" className="text-[var(--r2-cyan)] hover:underline">${r.symbol}</a></td>
                <td className="text-[var(--r2-text2)]" title={r.exit_reason}>{when(r.opened_at)} · {r.hold_s}s · {(r.exit_reason || "").replace("EMERGENCY EXIT — ", "").slice(0, 28)}</td>
                {COLS.map(([k]) => { const v = k === "60" ? r.pnl_pct : r.samples?.[k]; return <td key={k} className={tone(v)}>{pct(v)}</td>; })}
              </tr>
            ))}
          </tbody>
        </table>
      ) : <div className="mt-1 text-[var(--r2-text2)]" data-testid="fast-mover-scorecard-empty">No fast-mover trades yet — the first one shows here 60 seconds after it's bought.</div>}
    </div>
  );
};
